(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileCsv', GFileCsv);

    GFileCsv.$inject = ['$resource'];

    function GFileCsv ($resource) {
        var resourceUrl =  'api/g-files-csv';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
